import React from 'react';
import { MuiThemeProvider, CssBaseline } from '@material-ui/core';

import Session from '../../modules/Session';
import {
  healthCheck,
  login,
  LOGIN_STATES,
  HUBBLE_SESSION_AUTH,
} from '../../modules/Login';
import SpeakeasyTradesProvider from '../../modules/Trades/SpeakeasyTrades';
import AndromedaProvider from '../../modules/Andromeda';
import YodleeProvider from '../../modules/Yodlee/Yodlee';
import WorkflowsProvider from '../../modules/Workflows';
import WorkflowRunsProvider from '../../modules/WorkflowRuns';
import {
  PlanSponsorProvider,
  ParticipantProvider,
  DirectDetailsProvider,
  MFAProvider,
  FundBuilderProvider,
  FactSheetFilesProvider,
} from '../../modules/admin';
import SignalRProvider from '../../modules/SignalR';

import { Light } from '../../themes/index';
import ReportsProvider from '../../modules/Reports';
import { AppContextProvider } from '../../modules/AppContext';
import PermissionsProvider from '../../modules/Permissions';

import AppView from './App-view';

const App = () => {
  const { loginStatus, token } = Session.get(HUBBLE_SESSION_AUTH) || {};

  if (!loginStatus && !(token && token !== 'undefined')) {
    login();
    return null;
  }
  if (loginStatus === LOGIN_STATES.loggedin) {
    healthCheck();
  }

  return (
    <AppContextProvider>
      <PermissionsProvider>
        <YodleeProvider>
          <AndromedaProvider>
            <SpeakeasyTradesProvider>
              <WorkflowsProvider>
                <WorkflowRunsProvider>
                  <ReportsProvider>
                    <PlanSponsorProvider>
                      <ParticipantProvider>
                        <DirectDetailsProvider>
                          <MFAProvider>
                            <SignalRProvider>
                              <FundBuilderProvider>
                                <FactSheetFilesProvider>
                                  <CssBaseline />
                                  <MuiThemeProvider theme={Light}>
                                    <AppView />
                                  </MuiThemeProvider>
                                </FactSheetFilesProvider>
                              </FundBuilderProvider>
                            </SignalRProvider>
                          </MFAProvider>
                        </DirectDetailsProvider>
                      </ParticipantProvider>
                    </PlanSponsorProvider>
                  </ReportsProvider>
                </WorkflowRunsProvider>
              </WorkflowsProvider>
            </SpeakeasyTradesProvider>
          </AndromedaProvider>
        </YodleeProvider>
      </PermissionsProvider>
    </AppContextProvider>
  );
};
export default App;
